import React, { Component } from "react";
import { Button, FileField, StringField } from "@culturehq/components";

import { Trans } from "app/utils";

import styles from "./google-integration-form.module.scss";

class GoogleIntegrationForm extends Component {
  webhookUrlField = React.createRef();

  state = {
    submitting: false,
    verification: null,
    credentials: null,
    credentialsFile: null
  };

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  getSubmitEnabled() {
    const { submitting, verification, credentials } = this.state;

    return submitting || (!verification || !credentials);
  }

  handleVerificationChange = verificationFile => {
    const verification = (
      verificationFile ? verificationFile.name.replace(".html", "") : null
    );

    this.setState({ verification, verificationFile });
  };

  handleCopyWebhookUrl = () => {
    document.querySelector("input[name='webhook-url']").select();
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  };

  handleCredentialsChange = credentialsFile => {
    this.setState({ credentialsFile });

    if (!credentialsFile) {
      this.setState({ credentials: null });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      if (this.componentIsMounted) {
        this.setState({ credentials: reader.result });
      }
    };

    reader.readAsText(credentialsFile);
  };

  handleSubmit = () => {
    const { onCreate } = this.props;
    const { verification, credentials } = this.state;

    this.setState({ submitting: true });

    onCreate({ verification, credentials });
  };

  render() {
    const { webhookUrl } = this.props;
    const { verificationFile, credentialsFile } = this.state;

    return (
      <div className={styles.form}>
        <StringField
          readOnly
          value={webhookUrl}
          name="webhook-url"
        >
          <Trans>Webhook URL</Trans>
          <Button
            className="pull-right"
            small
            inverted
            icon="clipboard"
            onClick={this.handleCopyWebhookUrl}
          >
            <Trans>Copy</Trans>
          </Button>
        </StringField>
        <FileField
          value={verificationFile}
          name="verification"
          accept="text/html,.html"
          required
          onChange={this.handleVerificationChange}
        >
          <Trans>Verification File</Trans>
        </FileField>
        <FileField
          value={credentialsFile}
          name="credentials"
          accept="application/json,.json"
          required
          onChange={this.handleCredentialsChange}
        >
          <Trans>Credentials File</Trans>
        </FileField>
        <Button
          className={styles.submit}
          primary
          onClick={this.handleSubmit}
          disabled={this.getSubmitEnabled()}
        >
          <Trans>Configure</Trans>
        </Button>
      </div>
    );
  }
}

export default GoogleIntegrationForm;
